<template>
  <v-container>
    <!--   Diálogo para Mostrar un mensaje al Eliminar Guardias     -->
    <v-dialog
        v-model="signDialog"
        max-width="450"
    >
      <v-card>
        <v-card-title class="headline">
          {{$t('msg_health_form_sign_teacher')}}
        </v-card-title>
        <v-card-actions>
          <v-btn
              class="white--text"
              color="red"
              @click="signDialog = false"
          >
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              @click="signHealthForm()"
          >
            {{$t('Si')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout calign-center >
      <v-flex>
        <v-card class="elevation-5">
          <v-card-text>
            <v-layout>
              <v-flex>
                <v-card class="elevation-5">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>
                      {{$t('unsigned_health_form')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                      <v-flex>
                        <v-card-title>
                          {{$t('school_staff')}}
                          <v-spacer></v-spacer>
                          <v-text-field
                              clearable
                              outlined
                              v-model="search"
                              append-icon="mdi-account-search"
                              :label="$t('Buscar')"
                              single-line
                              hide-details
                          ></v-text-field>
                        </v-card-title>
                        <v-data-table
                            :headers="headersTeachers"
                            :loading="loadingDataTeachers"
                            :search="search"
                            :items="teachers"
                            multi-sort
                            :footer-props="{
                                itemsPerPageOptions: [
                                    {text: this.$t('todos'), value: -1}
                                ],
                                itemsPerPageText: $t('filas_por_pagina')
                            }"
                            class="elevation-1"
                            :no-data-text="$t('no_registros')"
                        >
                          <template v-slot:item.signed="{ item }">
                            <div v-if="!item.signed">
                              <v-btn
                                  block
                                   @click="signDialog = true, idTeacher = item.id"
                                  color="primary">
                                {{$t('sign')}}
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                  block
                                  disabled
                                  color="primary">
                                {{$t('signed')}}
                              </v-btn>
                            </div>
                          </template>
                          <template v-slot:no-results>
                            <v-alert type="warning">
                              {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import {HTTP} from '@/main.js'


export default {
  name: "unsigned_format",
  data: () => ({
    headersTeachers: [],
    loadingDataTeachers: false,
    search: '',
    signDialog: false,
    idTeacher: 0,
    teachers: []
  }),
  created () {
    this.getTeachers()
  },
  beforeUpdate () {
    this.headersTeachers = [
      {
        text: this.$t('health_format'),
        align: 'left',
        sortable: true,
        value: 'signed'
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'idUser.last_name'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    }
  },
  methods: {
    signHealthForm () {
      HTTP.post('health_by_teacher/vigilant',
        {
          idTeacher: this.idTeacher
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
      })
      .then(ok => {
        console.log(ok)
        // console.log('Guard con ID = ', this.idTeacher + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', this.$t('sign_health_form_success'))
        this.getTeachers()
        setTimeout(this.clear, 3000)
        this.signDialog = false
      })
      .catch(error => {
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    getTeachers () {
      this.loadingDataTeachers = true
      HTTP.get('teacher_signed/', {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response)
        if (response.status === 204) {
          this.teachers = []
        } else {
          this.teachers  = response.data
        }
        this.loadingDataTeachers = false
      })
      .catch(error => {
        this.loadingDataTeachers = false
        console.log(error)
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>